// frontend/src/components/common/Textarea.jsx
// COMPONENTE TEXTAREA REUTILIZABLE
import React from 'react';
import styled from 'styled-components';

// CONTAINER DEL CAMPO
// Margin reducido para filas más compactas
const FieldContainer = styled.div`
  margin-bottom: 0.5rem;
  &.fullHeight {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin-bottom: 0;
  }
`;

// LABEL DEL CAMPO
const Label = styled.label`
  display: block;
  margin-bottom: 0.15rem;
  color: ${({ theme }) => theme.colors.txtPrincipal};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-size: 0.875rem;
`;

// TEXTAREA ESTILIZADA
const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 0.35rem 0.6rem;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.txtPrincipal};
  font-size: 0.85rem;
  font-family: inherit;
  resize: vertical;
  min-height: 64px;
  &.fullHeight {
    min-height: unset;
    height: 100%;
    resize: none; /* avoid extra resize messing vertical layout when stretched */
  }
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}20;
  }
  
  &:disabled {
    background: ${({ theme }) => theme.colors.surfaceDisabled};
    color: ${({ theme }) => theme.colors.txtSecondary};
    cursor: not-allowed;
  }
  
  &.error {
    border-color: ${({ theme }) => theme.colors.danger};
  }
`;

// MENSAJE DE ERROR
const ErrorMessage = styled.span`
  display: block;
  margin-top: 0.25rem;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.75rem;
`;

// COMPONENTE TEXTAREA
const Textarea = ({ 
  label, 
  error, 
  rows = 3,
  className,
  fullHeight = false,
  ...props 
}) => {
  const containerClass = fullHeight ? 'fullHeight' : '';
  const textareaClass = `${fullHeight ? 'fullHeight' : ''} ${error ? 'error' : ''}`.trim();

  return (
    <FieldContainer className={containerClass}>
      {label && <Label>{label}</Label>}
      <StyledTextarea 
        rows={rows}
        className={textareaClass || className}
        {...props}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FieldContainer>
  );
};

export default Textarea;
